<div class="w-full px-4">
  <div class="w-full flex flex-column gap-3">
    <div class="peer-header">
      <h1 class="text-left text-3xl font-medium">Peer Signup</h1>
      <p-button icon="pi pi-list" (click)="peerList()" label="Peer List"
        styleClass="submitBtn" />
    </div>
    <form [formGroup]="newPeerForm" (ngSubmit)="onSubmit()">
      <div class="w-full flex flex-column gap-3">
        <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2"
          formGroupName="peerInformation">
          <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">Peer Information</h2>
          <div class="w-full flex flex-wrap">
            <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
              <b class="text-left font-normal text-base" style="color: #424242;">First Name</b>
              <input type="text" formControlName="firstName" class="inputField">
              <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="newPeerForm.get('peerInformation')?.get('firstName')?.invalid && (submitted || newPeerForm.get('peerInformation')?.get('firstName')?.touched)">
                First Name is required
              </small>
            </div>
            <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
              <b class="text-left font-normal text-base" style="color: #424242;">Last Name</b>
              <input type="text" formControlName="lastName" class="inputField">
              <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="newPeerForm.get('peerInformation')?.get('lastName')?.invalid && (submitted || newPeerForm.get('peerInformation')?.get('lastName')?.touched)">
                Last Name is required
              </small>
            </div>
            <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
              <b class="text-left font-normal text-base" style="color: #424242;">Email Address</b>
              <input type="text" formControlName="emailAddress" class="inputField">
              <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="newPeerForm.get('peerInformation')?.get('emailAddress')?.invalid && (submitted || newPeerForm.get('peerInformation')?.get('emailAddress')?.touched)">
                Email is missing or invalid
              </small>
            </div>
            <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
              <b class="text-left font-normal text-base" style="color: #424242;">Contact Number</b>
              <input type="text" formControlName="contactNumber" class="inputField">
              <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="newPeerForm.get('peerInformation')?.get('contactNumber')?.invalid && (submitted || newPeerForm.get('peerInformation')?.get('contactNumber')?.touched)">
                Contact number is missing or invalid
              </small>
            </div>
            <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
              <b class="text-left font-normal text-base" style="color: #424242;">Upload Image</b>
              <div class="flex align-items-center gap-2">
                <p-fileUpload mode="basic" #fileUploader (onSelect)="onFileSelect($event)" [auto]="false"
                  chooseLabel="Choose" chooseIcon="pi pi-upload" name="demo[]"
                  url="https://www.primefaces.org/cdn/api/upload.php" accept=".jpg,.png,.jpeg" maxFileSize="1000000"
                  class="w-full" styleClass="upload_w"></p-fileUpload>
                <ng-container *ngIf="uploadedImageUrl">
                  <div class="image-thumbnail-container" tabindex="0">
                    <img [src]="uploadedImageUrl" alt="Uploaded" class="image-thumbnail" />
                    <div class="image-preview">
                      <img [src]="uploadedImageUrl" alt="Large Preview" class="image-large" />
                    </div>
                  </div>
                </ng-container>
                <p-button *ngIf="attachment" class="font-regular" (onClick)="onFileRemoved()" icon="pi pi-times"
                  styleClass="closeIcon" [rounded]="true" appendTo="body" pTooltip="Clear image"
                  tooltipPosition="top" />
              </div>
            </div>
            <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
              <b class="text-left font-normal text-base" style="color: #424242;">Gender</b>
              <p-dropdown formControlName="gender" [options]="genders" formControlName="gender"
                [ngClass]="{'ng-invalid ng-dirty' : submitted }" optionLabel="name" placeholder="Select"
                styleClass="dropdown selectFull" appendTo="body" class="w-full">
                <ng-template pTemplate="selectedItem" let-selectedOption>
                  <div class="flex align-items-center gap-2">
                    <div>{{ selectedOption.name }}</div>
                  </div>
                </ng-template>
                <ng-template let-option pTemplate="item">
                  <div class="flex align-items-center gap-2">
                    <div>{{ option.name }}</div>
                  </div>
                </ng-template>
              </p-dropdown>
              <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="newPeerForm.get('peerInformation')?.get('gender')?.invalid && (submitted || newPeerForm.get('peerInformation')?.get('gender')?.touched)">
                Last Name is required
              </small>
            </div>
          </div>
        </div>
        <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
          <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">Peer Profile</h2>
          <div class="w-full flex flex-wrap" formGroupName="peerProfile">

            <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
              <b class="text-left font-normal text-base" style="color: #424242;">City</b>
              <input type="text" formControlName="city" class="inputField">
              <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="newPeerForm.get('peerProfile')?.get('city')?.invalid && (submitted || newPeerForm.get('peerProfile')?.get('city')?.touched)">
                City is required
              </small>
            </div>
            <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
              <b class="text-left font-normal text-base" style="color: #424242;">Country</b>
              <p-dropdown optionLabel="name" optionValue="name" formControlName="country" [options]="countries"
                [showClear]="true" [filter]="true" filterBy="name" [ngClass]="{'ng-invalid ng-dirty' : submitted }"
                placeholder="Select a Country" class="w-full" styleClass="dropdown_ss" />
              <small class="ng-dirty ng-invalid text-red-500"
                *ngIf="newPeerForm.get('peerProfile')?.get('country')?.invalid && (submitted || newPeerForm.get('peerProfile')?.get('country')?.touched)">
                Country is required
              </small>
            </div>
            <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
              <b class="text-left font-normal text-base" style="color: #424242;">Origin City</b>
              <input type="text" formControlName="originCity" class="inputField">
            </div>
            <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
              <b class="text-left font-normal text-base" style="color: #424242;">Origin Country</b>
              <p-dropdown optionLabel="name" optionValue="name" formControlName="originCountry" [options]="countries"
                [showClear]="true" [filter]="true" filterBy="name"
                placeholder="Select a Country" class="w-full" styleClass="dropdown_ss" />
            </div>
          </div>
          <div class="w-full flex flex-column gap-2 mt-2 pt-4 border-top-1" style="border-color: #d0d0d0;"
            formGroupName="highSchoolInformation">
            <h2 class="text-left text-base font-medium px-2" style="color: #101011;">High school Information</h2>
            <div class="w-full flex flex-wrap">
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Name of High school</b>
                <input type="text" formControlName="nameOfHighSchool" class="inputField">
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="newPeerForm.get('highSchoolInformation')?.get('nameOfHighSchool')?.invalid && (submitted || newPeerForm.get('highSchoolInformation')?.get('nameOfHighSchool')?.touched)">
                  High school name is required
                </small>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Board</b>
                <input type="text" formControlName="board" class="inputField">
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="newPeerForm.get('highSchoolInformation')?.get('board')?.invalid && (submitted || newPeerForm.get('highSchoolInformation')?.get('board')?.touched)">
                  Board name is required
                </small>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Coursework</b>
                <input type="text" formControlName="coursework" class="inputField">
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="newPeerForm.get('highSchoolInformation')?.get('coursework')?.invalid && (submitted || newPeerForm.get('highSchoolInformation')?.get('coursework')?.touched)">
                  Coursework is required
                </small>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Year graduated</b>
                <input type="text" formControlName="yearGraduatedHighSchool" class="inputField">
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="newPeerForm.get('highSchoolInformation')?.get('yearGraduatedHighSchool')?.invalid && (submitted || newPeerForm.get('highSchoolInformation')?.get('yearGraduatedHighSchool')?.touched)">
                  Year graduated is required
                </small>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Class X grades</b>
                <input type="text" formControlName="classXGrades" class="inputField">
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="newPeerForm.get('highSchoolInformation')?.get('classXGrades')?.invalid && (submitted || newPeerForm.get('highSchoolInformation')?.get('classXGrades')?.touched)">
                  Class X grade is required
                </small>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Class XII grades</b>
                <input type="text" formControlName="classXIIGrades" class="inputField">
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="newPeerForm.get('highSchoolInformation')?.get('classXIIGrades')?.invalid && (submitted || newPeerForm.get('highSchoolInformation')?.get('classXIIGrades')?.touched)">
                  Class XII grade is required
                </small>
              </div>
            </div>
          </div>
          <div class="w-full flex flex-column gap-2 mt-2 pt-4 border-top-1" style="border-color: #d0d0d0;"
            formGroupName="undergraduateCollegeInformation">
            <h2 class="text-left text-base font-medium px-2" style="color: #101011;">Undergraduate College Information
            </h2>
            <div class="w-full flex flex-wrap">
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Name of Undergraduate College</b>
                <input type="text" formControlName="nameOfUndergraduateCollege" class="inputField">
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="newPeerForm.get('undergraduateCollegeInformation')?.get('nameOfUndergraduateCollege')?.invalid && (submitted || newPeerForm.get('undergraduateCollegeInformation')?.get('nameOfUndergraduateCollege')?.touched)">
                  Name of Undergraduate College is required
                </small>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Country of college</b>
                <p-dropdown optionLabel="name" optionValue="name" formControlName="countryOfUndergraduateCollege"
                  [options]="countries" [showClear]="true" [filter]="true" filterBy="name"
                  [ngClass]="{'ng-invalid ng-dirty' : submitted }" placeholder="Select a Country" class="w-full"
                  styleClass="dropdown_ss" />
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="newPeerForm.get('undergraduateCollegeInformation')?.get('countryOfUndergraduateCollege')?.invalid && (submitted || newPeerForm.get('undergraduateCollegeInformation')?.get('countryOfUndergraduateCollege')?.touched)">
                  Country of college is required
                </small>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">City of college</b>
                <input type="text" formControlName="cityOfUndergraduateCollege" class="inputField">
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="newPeerForm.get('undergraduateCollegeInformation')?.get('cityOfUndergraduateCollege')?.invalid && (submitted || newPeerForm.get('undergraduateCollegeInformation')?.get('cityOfUndergraduateCollege')?.touched)">
                  City of college is required
                </small>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Major / Degree</b>
                <input type="text" formControlName="majorUndergraduate" class="inputField">
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="newPeerForm.get('undergraduateCollegeInformation')?.get('majorUndergraduate')?.invalid && (submitted || newPeerForm.get('undergraduateCollegeInformation')?.get('majorUndergraduate')?.touched)">
                  Major / Degree is required
                </small>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Year graduated / expected graduation
                  year</b>
                <input type="text" formControlName="yearGraduatedUndergraduate" class="inputField">
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="newPeerForm.get('undergraduateCollegeInformation')?.get('yearGraduatedUndergraduate')?.invalid && (submitted || newPeerForm.get('undergraduateCollegeInformation')?.get('yearGraduatedUndergraduate')?.touched)">
                  Year graduated / expected graduation year is required
                </small>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Expected grade (if mentioned)</b>
                <input type="text" formControlName="expectedGradeUndergraduate" class="inputField">
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="newPeerForm.get('undergraduateCollegeInformation')?.get('expectedGradeUndergraduate')?.invalid && (submitted || newPeerForm.get('undergraduateCollegeInformation')?.get('expectedGradeUndergraduate')?.touched)">
                  Grade is required
                </small>
              </div>
            </div>
          </div>
          <div class="w-full flex flex-column gap-2 mt-2 pt-4 border-top-1" style="border-color: #d0d0d0;"
            formGroupName="graduateCollegeInformation">
            <h2 class="text-left text-base font-medium px-2" style="color: #101011;">Graduate College Information</h2>
            <div class="w-full flex flex-wrap">
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Name of Graduate College</b>
                <input type="text" formControlName="nameOfGraduateCollege" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Country of college</b>
                <p-dropdown optionLabel="name" optionValue="name" formControlName="countryOfGraduateCollege"
                  [options]="countries" [showClear]="true" [filter]="true" filterBy="name"
                  placeholder="Select a Country" class="w-full" styleClass="dropdown_ss" />
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">City of college</b>
                <input type="text" formControlName="cityOfGraduateCollege" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Major / Degree</b>
                <input type="text" formControlName="majorGraduate" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Year graduated / expected graduation
                  year</b>
                <input type="text" formControlName="yearGraduatedGraduate" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Expected grade (if mentioned)</b>
                <input type="text" formControlName="expectedGradeGraduate" class="inputField">
              </div>
            </div>
          </div>
          <div class="w-full flex flex-column gap-2 mt-2 pt-4 border-top-1" style="border-color: #d0d0d0;"
            formGroupName="testScores">
            <h2 class="text-left text-base font-medium px-2" style="color: #101011;">Test Scores</h2>
            <div class="w-full flex flex-wrap">
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">SAT OVERALL</b>
                <input type="text" formControlName="satOverall" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">SAT ENGLISH</b>
                <input type="text" formControlName="satEnglish" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">SAT MATH</b>
                <input type="text" formControlName="satMath" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">ACT OVERALL</b>
                <input type="text" formControlName="actOverall" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">ACT ENGLISH</b>
                <input type="text" formControlName="actEnglish" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">ACT MATH</b>
                <input type="text" formControlName="actMath" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">GRE</b>
                <input type="text" formControlName="gre" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">GMAT</b>
                <input type="text" formControlName="gmat" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">IELTS</b>
                <input type="text" formControlName="ielts" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">TOEFL</b>
                <input type="text" formControlName="toefl" class="inputField">
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">AP</b>
                <input type="text" formControlName="ap" class="inputField">
              </div>
            </div>
          </div>
        </div>
        <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
          <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">Extracurricular activities description
          </h2>
          <textarea name="" rows="3" cols="30" pInputTextarea formControlName="extracurricularActivities"
            class="w-full"></textarea>
        </div>
        <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
          <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">Short Bio</h2>
          <textarea name="" rows="3" cols="30" pInputTextarea formControlName="shortBio" class="w-full"></textarea>
        </div>
        <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
          <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">Employment history</h2>

          <div formArrayName="employmentHistory">
            <div class="w-full flex flex-wrap" *ngFor="let item of employeeHistoryList.controls; let i = index"
              [formGroupName]="i">
              <div class="col-12 sm:col-6 md:col-8 xl:col-9 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Company name</b>
                <input type="text" formControlName="companyName" class="inputField">
                <!-- <p-autoComplete formControlName= "companyName" [suggestions]="places"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && !newPeerForm.get('companyName')?.value}"
                  class="w-full" (completeMethod)="filterPlaces($event)" styleClass="autocom"
                  optionLabel="name">
                  <ng-template let-place pTemplate="item">
                    {{ place.name }}
                  </ng-template>

                  <ng-template let-place pTemplate="selectedItem">
                    {{ place.name }}
                  </ng-template>
                </p-autoComplete> -->

                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="item.get('companyName')?.invalid && (submitted || item.get('companyName')?.touched)">
                  Company name is required
                </small>
              </div>
              <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
                <b class="text-left font-normal text-base" style="color: #424242;">Role</b>
                <div class="w-auto inline-flex align-items-center gap-1">
                  <input type="text" formControlName="role" class="inputField">
                  <p-button (click)="removeCompany(i)" icon="pi pi-times-circle" styleClass="removeSlot" />
                </div>
                <small class="ng-dirty ng-invalid text-red-500"
                  *ngIf="item.get('role')?.invalid && (submitted || item.get('role')?.touched)">
                  Role is required
                </small>
              </div>
            </div>
          </div>
          <p-button (onClick)="addCompany()" label="Add another" styleClass="save_btn1" />
        </div>
        <div class="w-full flex align-items-center justify-content-center">
          <p-button [loading]="isLoading" label="Submit" styleClass="save_btn1" type="submit" />
        </div>
      </div>
    </form>
  </div>
</div>



<!-- <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
            <b class="text-left font-normal text-base" style="color: #424242;">Alias Name</b>
            <input type="text" class="inputField">
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-3 flex flex-column gap-1">
            <b class="text-left font-normal text-base" style="color: #424242;">Animated image</b>
            <p-fileUpload
              mode="basic"
              chooseLabel="Choose"
              chooseIcon="pi pi-upload"
              name="demo[]"
              url="https://www.primefaces.org/cdn/api/upload.php"
              accept="image/*"
              maxFileSize="1000000" class="w-full" styleClass="upload_w" />
          </div> -->
